var BaseView = require('../../../customize/contents/sticker/stickers');

module.exports = BaseView.extend({
  callbackName: 'callbackAdminStickers',

  getParams: function () {
    var params = {
      from: this.from,
      limit: this.limit,
      where: { category: this.category.name, active: INKIVE.C.USER.IS_SUPER ? 0 : 1 }
    };

    this.from += this.limit;

    return params;
  }

});
